import {initialQueryState, KTIcon} from '../../../../../_metronic/helpers'
import useAuthorization from '../../../../../hooks/useAuthorization'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {useState} from 'react'
import {ListSearchSubscriptionStatus} from './ListSearchSubscriptionStatus'
import {Option} from 'react-multi-select-component'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {ListSearchSubscriptionDate} from './ListSearchSubscriptionDate'
import {useFilterExport} from '../../core/FilterProvider'
import qs from 'qs'
import {ListSearchNumberContract} from './ListSearchNumberContract'
import {ListSearchComponent} from './ListSearchComponent'
import {ListSearchSubscriptionCategories} from './ListSearchSubscriptionCategories'
import {ListSearchSubscriptionType} from './ListSearchSubscriptionType'
import {ListSearchSubscriptionItems} from './ListSearchSubscriptionItems'
import {ListSearchFranchises} from '../../../../../components/ListSearchFranchise/ListSearchFranchises'
import {useReportConfig} from '../../ConfigContext'
import {useMemo} from 'react'
import Swal from 'sweetalert2'
import {downloadServerFile} from '../../core/_requests'

const ListToolbar = () => {
  const config = useReportConfig()
  const isAuthorizedToCreate = useAuthorization(config.authPermission)
  const isAuthorizedToExport = useAuthorization(config.exportPermission)

  const {filterExport, setFilterExport} = useFilterExport()

  const {updateState} = useQueryRequest()

  const {isLoading} = useQueryResponse()

  const [searchDateStart, setSearchDateStart] = useState<string>('')
  const [searchDateFinish, setSearchDateFinish] = useState<string>('')
  const [searchClientName, setSearchClientName] = useState<string>('')

  const [errors, setErrors] = useState<string[]>([])

  const [subscriptionStatusSearch, setSubscriptionStatusSearch] = useState<string>('')
  const [selectsSaleStatus, setSelectsSaleStatus] = useState<Option[]>([])

  const [searchNumberContract, setSearchNumberContract] = useState<string>('')

  // Detail-specific filters
  const [subscriptionCategoriesSearch, setSubscriptionCategoriesSearch] = useState<string>('')
  const [selectsCategories, setSelectsCategories] = useState<Option[]>([])

  const [subscriptionTypeSearch, setSubscriptionTypeSearch] = useState<string>('')
  const [selectsTypes, setSelectsTypes] = useState<Option[]>([])

  const [subscriptionItemsSearch, setSubscriptionItemsSearch] = useState<string>('')
  const [selectsItems, setSelectsItems] = useState<Option[]>([])

  // Franchise filter (KPI only)
  const [selectsFranchises, setSelectsFranchises] = useState<Option[]>([])
  const [selectsFranchisesSearch, setSelectsFranchisesSearch] = useState<string>('')

  if (!isAuthorizedToCreate) return <></>

  const resetData = () => {
    const resetObj: any = {
      status: '',
      categories: '',
      types: '',
      items: '',
      dtStart: '',
      dtEnd: '',
      ...initialQueryState,
    }

    if (config.showFranchiseFilter) {
      resetObj.franchises = ''
    }
    if (config.reportType === 'summary') {
      resetObj.contract = searchNumberContract
      resetObj.client_name = searchClientName
    }

    setFilterExport(resetObj)
    updateState(resetObj)

    if (config.showFranchiseFilter) {
      setSelectsFranchisesSearch('')
      setSelectsFranchises([])
    }
    setSubscriptionStatusSearch('')
    setSelectsSaleStatus([])
    if (config.reportType === 'detail') {
      setSubscriptionCategoriesSearch('')
      setSelectsCategories([])
      setSubscriptionTypeSearch('')
      setSelectsTypes([])
      setSubscriptionItemsSearch('')
      setSelectsItems([])
    }
    setSearchDateStart('')
    setSearchDateFinish('')
    if (config.reportType === 'summary') {
      setSearchNumberContract('')
      setSearchClientName('')
    }
    setErrors([])
  }

  const filterData = () => {
    const filterObj: any = {
      status: subscriptionStatusSearch ? `${subscriptionStatusSearch}` : '',
      dtStart: searchDateStart,
      dtEnd: searchDateFinish,
      ...initialQueryState,
    }

    if (config.showFranchiseFilter) {
      filterObj.franchises = selectsFranchisesSearch ? `${selectsFranchisesSearch}` : ''
    }
    if (config.reportType === 'summary') {
      filterObj.contract = searchNumberContract
      filterObj.client_name = searchClientName
    }
    if (config.reportType === 'detail') {
      filterObj.categories = subscriptionCategoriesSearch ? `${subscriptionCategoriesSearch}` : ''
      filterObj.types = subscriptionTypeSearch ? `${subscriptionTypeSearch}` : ''
      filterObj.items = subscriptionItemsSearch ? `${subscriptionItemsSearch}` : ''
    }

    setFilterExport(filterObj)
    updateState(filterObj)

    const closeButton = document.querySelector<HTMLButtonElement>('#kt_drawer_filter_close')

    if (closeButton) {
      closeButton.click()
    }
  }

  function isNotEmpty(obj: unknown) {
    return obj !== undefined && obj !== null && obj !== ''
  }

  const cleanedFilterExport = Object.keys(filterExport)
    .filter(
      (key) =>
        filterExport[key] !== '' &&
        filterExport[key] !== 0 &&
        key !== 'page' &&
        key !== 'per_page' &&
        key !== 'total'
    )
    .reduce((obj, key) => {
      obj[key] = filterExport[key]
      return obj
    }, {})

  const downloadFile = async () => {
    try {
      const result = await downloadServerFile(
        isNotEmpty(cleanedFilterExport) ? qs.stringify(cleanedFilterExport) : undefined,
        config.reportsBaseUrl,
        config.exportEndpoint,
        config.exportFileName
      )
      if (result && result.message) {
        Swal.fire({
          icon: 'info',
          title: 'Relatório em processamento',
          text: result.message,
          confirmButtonColor: '#d33',
        })
      }
    } catch (error: any) {
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error?.response?.data?.message,
        timer: 2000,
      })
    }
  }

  return (
    <>
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-danger me-3'
        id='kt_drawer_filter_button'
      >
        <KTIcon iconName='filter' className='fs-2' />
        Filtrar
      </button>
      <div
        id='kt_drawer_filter'
        className='bg-body'
        data-kt-drawer='true'
        data-kt-drawer-name='activities'
        data-kt-drawer-activate='true'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'300px', 'lg': '500px'}"
        data-kt-drawer-direction='end'
        data-kt-drawer-toggle='#kt_drawer_filter_button'
        data-kt-drawer-close='#kt_drawer_filter_close'
      >
        <div className='card shadow-none rounded-0'>
          <div className='card-header' id='kt_activities_header'>
            <h3 className='card-title fw-bolder text-dark'>Opcoes de Filtro</h3>

            <div className='card-toolbar'>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-active-light-danger me-n5'
                id='kt_drawer_filter_close'
              >
                <KTIcon iconName='cross' className='fs-1' />
              </button>
            </div>
          </div>
          <div className='card-body position-relative' id='kt_activities_body'>
            <div className='timeline'>
              <div className='px-7 py-5' data-kt-user-table-filter='form'>
                <div className='row'>
                  {config.showFranchiseFilter && (
                    <div className='col-12 '>
                      <ListSearchFranchises
                        setSelectsFranchisesSearch={setSelectsFranchisesSearch}
                        selectsFranchises={selectsFranchises}
                        setSelectsFranchises={setSelectsFranchises}
                        label='Pesquisar por Unidade:'
                      />
                    </div>
                  )}
                  <div className='col-12'>
                    <ListSearchSubscriptionDate
                      setSearchDateStart={setSearchDateStart}
                      searchDateStart={searchDateStart}
                      searchDateFinish={searchDateFinish}
                      setSearchDateFinish={setSearchDateFinish}
                      setErrors={setErrors}
                      errors={errors}
                    />
                  </div>

                  <div className='col-12 '>
                    <ListSearchSubscriptionStatus
                      setSubscriptionStatusSearch={setSubscriptionStatusSearch}
                      selectsSaleStatus={selectsSaleStatus}
                      setSelectsSaleStatus={setSelectsSaleStatus}
                    />
                  </div>

                  {config.reportType === 'summary' && (
                    <>
                      <div className='col-12'>
                        <ListSearchNumberContract
                          searchNumberContract={searchNumberContract}
                          setSearchNumberContract={setSearchNumberContract}
                        />
                      </div>

                      <div className='col-12'>
                        <ListSearchComponent
                          searchClientName={searchClientName}
                          setSearchClientName={setSearchClientName}
                        />
                      </div>
                    </>
                  )}

                  {config.reportType === 'detail' && (
                    <>
                      <div className='col-12'>
                        <ListSearchSubscriptionCategories
                          setSubscriptionCategoriesSearch={setSubscriptionCategoriesSearch}
                          selectsCategories={selectsCategories}
                          setSelectsCategories={setSelectsCategories}
                        />
                      </div>
                      <div className='col-12'>
                        <ListSearchSubscriptionType
                          setSubscriptionTypeSearch={setSubscriptionTypeSearch}
                          selectsTypes={selectsTypes}
                          setSelectsTypes={setSelectsTypes}
                        />
                      </div>
                      <div className='col-12'>
                        <ListSearchSubscriptionItems
                          setSubscriptionItemsSearch={setSubscriptionItemsSearch}
                          selectsItems={selectsItems}
                          setSelectsItems={setSelectsItems}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='card-footer py-5 text-center' id='kt_activities_footer'>
            <div className='d-flex justify-content-end'>
              <button
                type='button'
                disabled={isLoading}
                onClick={resetData}
                className='btn btn-secondary fw-bold me-2 px-6'
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='reset'
              >
                Limpar
              </button>
              <button
                disabled={isLoading || errors?.[0]?.length || errors?.[1]?.length ? true : false}
                type='button'
                onClick={filterData}
                className='btn btn-danger fw-bold px-6'
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='filter'
              >
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </div>
      {isAuthorizedToExport && (
        <button
          disabled={isLoading}
          type='button'
          className='btn btn-light-danger me-3'
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'
          onClick={() => {
            downloadFile()
          }}
        >
          <KTIcon iconName='exit-up' className='fs-2' />
          Export
        </button>
      )}
    </>
  )
}

export {ListToolbar}
